module.exports = __webpack_public_path__ + "img/jisushenhe.647c6ecb.png";